import { Chip, type ChipColor } from "@legal-500/legal500-design-system";
import type { CsVerificationStatus } from "@/api/customerSupportUsers.service";

export const CS_STATUS_LABEL: Record<string, string> = {
  verified: "Verified",
  pending_deletion: "Pending deletion",
  deleted: "Deleted",
  anonymised: "Anonymised",
};

export const csStatusLabel = (status: string) => CS_STATUS_LABEL[status] ?? status;

// The shared StatusBadge only styles draft/published and falls back to "draft" for anything
// else, so every CS status would render identically — an agent could not tell a live account
// from a deleted one at a glance, which is the whole point of the column.
const CS_STATUS_COLOR: Record<string, ChipColor> = {
  verified: "success",
  pending_deletion: "warning",
  deleted: "error",
  anonymised: "default",
};

export function CsStatusChip({ status }: { status: CsVerificationStatus | string }) {
  return (
    <Chip size="small" variant="filled" color={CS_STATUS_COLOR[status] ?? "default"}>
      {csStatusLabel(status)}
    </Chip>
  );
}
